import { LanguageCode } from '@mkp/shared/models';

const SUPPORT_CENTER_BASE_URL = 'https://service.jobcloud.ch/hc';

/** Zendesk section ID for the Legal & Imprint knowledge-base section */
const LEGAL_AND_IMPRINT_SECTION_ID = '45031319316113-Legal-Imprint';

/** Zendesk article ID for the cookie notice article */
const COOKIE_NOTICE_ARTICLE_ID = '45303208891409-Cookie-Notice';

/** Zendesk article ID for the data privacy notice article */
const PRIVACY_NOTICE_ARTICLE_ID = '45031670444049-Data-Privacy-Notice';

/** Zendesk article ID for the logo guidelines article */
const LOGO_GUIDELINES_ARTICLE_ID = '45070013805073';

/** Zendesk article ID for the product overview article */
const PRODUCT_OVERVIEW_ARTICLE_ID = '37995328475409';

const getLocale = (language: LanguageCode): string =>
  language === LanguageCode.ENGLISH ? 'en-us' : language;

export const getSupportCenterUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}`;

export const getLegalAndImprintUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}/sections/${LEGAL_AND_IMPRINT_SECTION_ID}`;

export const getCookieNoticeUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}/articles/${COOKIE_NOTICE_ARTICLE_ID}`;

export const getPrivacyNoticeUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}/articles/${PRIVACY_NOTICE_ARTICLE_ID}`;

export const getLogoGuidelinesUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}/articles/${LOGO_GUIDELINES_ARTICLE_ID}`;

export const getProductOverviewUrl = (language: LanguageCode): string =>
  `${SUPPORT_CENTER_BASE_URL}/${getLocale(language)}/articles/${PRODUCT_OVERVIEW_ARTICLE_ID}`;
